import {Component} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';

import { Browser } from '@capacitor/browser';

@Component({
  selector: 'help-page',
  templateUrl: 'help-page.html',
  styleUrls: ['help-page.scss'],
})
export class HelpPage {

  constructor(
    private translateService: TranslateService,
  ) { }

  public openLink(link: string): void {
    this.translateService
      .get('HELP.LINKS.' + link)
      .subscribe((url: string) => {
        Browser.open({url: url.replace(/\u00AD/g, '')});
      });
  }
}
